module.exports = __webpack_public_path__ + "static/bgMo3-bd7dc05a04608d09119df98ab38e4991.png";